export const SuspendModificationReason = {
  None: 0,
  Administrative: 1,
  TrialExceeded: 2,
  BillingPlanExceeded: 3,
  PaymentMethodSetToBankTransfer: 4,
  RenewTrial: 5,
  AcceptedBillingPlanUpgrade: 6,
  ShopifyPaymentConfirmation: 7,
  OverdueInvoices: 8,
};
